import { logger as LOG } from '@garnish/logger';

const name = 'Reorder';

export const reorderIfRequiredLogger = LOG.extend(name);

LOG.disable(name);
